import { cn } from '@/lib';
import { scrollStyleClass } from '@/utils/scrollClassHelper';
import React, { PropsWithChildren } from 'react';

const HEADER_DIVIDER_STYLE = { boxShadow: '0 1px 0 0 var(--color-border)' };


interface TableProps {
    tableClassName?: string;
    className?: string;
}

const Table: React.FC<PropsWithChildren<TableProps>> = ({ tableClassName, className, children }) => {
    return (
        <div className={cn("relative grow overflow-hidden", className)}>
            <div className={cn("absolute grow inset-0 overflow-auto", scrollStyleClass)}>
                <table className={cn("divide-border min-w-full", tableClassName)}>
                    {children}
                </table>
            </div>
        </div>
    );
};

export default Table;


interface TableHeader {
    style?: React.CSSProperties
}

export const TableHeader: React.FC<PropsWithChildren<TableHeader>> = ({ children, style }) => {
    return (
        <thead className="sticky top-0 z-10 bg-surface" style={{ ...HEADER_DIVIDER_STYLE, ...style }}>
            <tr>
                {children}
            </tr>
        </thead>
    );
};

// [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-scrollbar-track [&::-webkit-scrollbar-thumb]:bg-scrollbar-thumb

export const TableBody: React.FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => {
    return (
        <tbody className={cn("relative grow overflow-y-scroll divide-y divide-border", className)}>
            {children}
        </tbody>
    );
};


